import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as ResourceTypesActions from './resource-types.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class ResourceTypesStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new ResourceTypesActions.ResourceTypesRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.RESOURCE_TYPES, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new ResourceTypesActions.ResourceTypesCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new ResourceTypesActions.ResourceTypesUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new ResourceTypesActions.ResourceTypesDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new ResourceTypesActions.ResourceTypesRefresh());
          break;
      }
    });
  }
}
